// ProZpects Power Score — label bands and color tokens shared by web UI.
// Bands match section 4.B of the design doc (Verified Power Index).

export const POWER_SCORE_BANDS = [
  { min: 95, max: 100, label: 'Elite Verified Athlete',          color: '#b45309', bg: '#fef3c7' }, // gold
  { min: 90, max:  94, label: 'High Major Athletic Profile',     color: '#3F6B53', bg: '#dbeafe' },
  { min: 80, max:  89, label: 'College-Ready Athletic Profile',  color: '#0066cc', bg: '#e0ecff' },
  { min: 70, max:  79, label: 'Above Average Prospect',          color: '#0e7490', bg: '#cffafe' },
  { min: 60, max:  69, label: 'Developmental Prospect',          color: '#475569', bg: '#f1f5f9' },
  { min: 50, max:  59, label: 'Average / Baseline',              color: '#64748b', bg: '#f8fafc' },
  { min:  0, max:  49, label: 'Needs Development',               color: '#94a3b8', bg: '#f8fafc' },
];

export function bandFor(score) {
  if (score == null) return null;
  return POWER_SCORE_BANDS.find(b => score >= b.min && score <= b.max) || POWER_SCORE_BANDS[POWER_SCORE_BANDS.length - 1];
}
